const HOSTNAME = typeof window !== 'undefined' ? window.location.hostname : '';

export const Config = {
  MUX_ENV_KEY: process.env.MUX_ENV_KEY,
  DD_CLIENT_TOKEN: process.env.DD_CLIENT_TOKEN,
  DD_SITE: process.env.DD_SITE,
  DEBUG_MODE:
    HOSTNAME.startsWith('dev-') ||
    HOSTNAME === 'localhost' ||
    HOSTNAME === '127.0.0.1',
  NODE_ENV: process.env.NODE_ENV,

  /**
   * Build identity of this bundle, as `<commit date>-<short sha>` — e.g.
   * `2026-10-07-276617e`. Injected by the CI `build` job from
   * `CI_COMMIT_TIMESTAMP` and `CI_COMMIT_SHORT_SHA`; falls back to `local` for
   * hand-built bundles so those are never mistaken for a release.
   *
   * The repo carries no git tags and the `package.json` version is unused, so
   * this is the only identifier tying a running receiver back to a commit. It
   * is reported to Mux (`view_client_application_version`), Datadog
   * (`version`) and the boot log, which lets playback failures be attributed
   * to a specific deploy.
   */
  BUILD_VERSION: process.env.BUILD_VERSION,

  /**
   * P1 Fase 2 experiment (ID-1715). Build-time flag: set the CI/CD variable
   * `EXPERIMENT_START_LOW=true` and redeploy to run the experiment; unset (or
   * `false`) and redeploy to roll back. When enabled, the 1080p resolution cap
   * is **disabled** and playback starts at a low rendition (see
   * `LOW_START_BANDWIDTH_BPS`), letting ABR climb only as far as the device
   * sustains. Default `false` → cap active (production default). See
   * `player/playback-config.ts` and `App.buildPlaybackConfig`.
   */
  EXPERIMENT_START_LOW: process.env.EXPERIMENT_START_LOW === 'true',

  /**
   * Maximum playback resolution allowed on all devices — Full HD (1080p).
   * Applied via Shaka `restrictions` so any variant above 1920×1080 is
   * marked unplayable and never selected (matches market standard).
   */
  MAX_VIDEO_WIDTH: 1920,
  MAX_VIDEO_HEIGHT: 1080,

  /**
   * Initial ABR bandwidth estimate (bit/s) used by the P1 Fase 2 experiment
   * (`EXPERIMENT_START_LOW`). A low value forces ABR to start on the lowest
   * rendition (guaranteeing startup) and climb only as the device/network
   * sustain it. 1 Mbps comfortably selects a low variant on any BP profile.
   */
  LOW_START_BANDWIDTH_BPS: 1_000_000,
} as const;
